// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__1DZnl","error":"box_error__1vuji box_box__1DZnl","success":"box_success__YuwZr box_box__1DZnl"};